import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";
import MobileChangeDialog from "@/components/AccountPage/Security/SecurityTwoFactorAuth/Modals/MobileChangeDialog.vue";
import EmailChangeDialog from "@/components/AccountPage/Security/SecurityTwoFactorAuth/Modals/EmailChangeDialog.vue";
import RemoveGoogleAuth from "@/components/AccountPage/Security/SecurityTwoFactorAuth/Modals/RemoveGoogleAuth.vue";

const Stepper = () =>
  import(
    /* webpackChunkName: "Stepper" */ "@/components/AccountPage/Security/SecurityTwoFactorAuth/Stepper/index"
  );

const CountDown = () =>
  import(/* webpackChunkName: "count-down" */ "@/components/CountDown/index");

import { ContactService, OtpService, UserService } from "@/services";

import $enDigits from "@/mixins/enDigits";

export default {
  name: "security-two-factor-auth",
  components: {
    Stepper,
    CountDown,
    MobileChangeDialog,
    EmailChangeDialog,
    RemoveGoogleAuth
  },
  mixins: [$enDigits],
  data() {
    return {
      showModalHint: false,
      authModal: false,
      authModalStep: 1,
      smsModal: false,
      smsModalStep: 1,
      showSmsModalPass: false,
      emailModal: false,
      emailInput: "",
      emailCode: "",
      errorText: "",
      showMobileChangeDialog: false,
      showEmailChangeDialog: false,
      showGoogleAuthRemoveDialog: false,
      emailRules: [
        v =>
          !!v ||
          this.$t(
            "accountPage.identityInformation.contactInfo.email.emailValidation.empty"
          ),
        v =>
          /.+@.+/.test(v) ||
          this.$t(
            "accountPage.identityInformation.contactInfo.email.emailValidation.invalid"
          )
      ],
      step: 1,
      showPassword: false,
      showSmsPassword: false,
      qrCode: "",
      secretCode: "",
      authenticatorCode: "",
      smsCode: "",
      password: "",
      smsPassword: "",
      isMobileHover: false,
      isMobileFocus: false,
      mobile: "",
      isCountDownFinish: false,
      isRequesting: false,
      inactiveGoogleModal: false,
      inactiveSmsModal: false,
      inactiveGooglePassword: "",
      inactiveSmsPassword: "",
      showInactiveGooglePassword: false,
      showInactiveSmsPassword: false,
      ttl: "",
      googlePasswordType: "text",
      smsPasswordType: "text",
      smsCodeErrorText: "",
      smsPasswordErrorText: "",
      inactiveGooglePasswordError: false,
      inactiveSmsPasswordError: false,
      googleCodeError: false,
      googlePasswordError: false
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO,
      userVerifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO,
      modalStep: types.email.getters.MODAL_STEP
    }),
    emailDialogHeight() {
      switch (this.modalStep) {
        case 1:
          return "height: 349px;";

        case 2:
          return "height: 330px;";
      }
    },
    activeGoogleModalStyle() {
      switch (this.authModalStep) {
        case 1:
          if (this.$vuetify.breakpoint.xs) {
            return "height: 570px;";
          } else {
            return "height: 500px;";
          }
        case 2:
          if (this.$vuetify.breakpoint.xs) {
            return "height: 750px;";
          } else {
            return "height: 550px;";
          }
        case 3:
          if (this.$vuetify.breakpoint.xs) {
            return "height: 600px;";
          } else {
            return "height: 550px;";
          }
        case 4:
          if (this.$vuetify.breakpoint.xs) {
            return "height: 680px;";
          } else {
            return "height: 660px;";
          }
      }
    },

    activeSmsModalStyle() {
      switch (this.smsModalStep) {
        case 1:
          if (this.$vuetify.breakpoint.xs) {
            return "height: 400px;";
          } else {
            if (this.mobileData) {
              return "height: 250px;";
            } else {
              return "height: 380px;";
            }
          }
        case 2:
          if (this.$vuetify.breakpoint.xs) {
            return "height: 560px;";
          } else {
            return "height: 400px;";
          }
      }
    },

    defaultAuth: {
      get() {
        return this.userInfo?.two_factor_auth_default;
      },

      set(method) {
        switch (method) {
          case "google2fa":
            this.setDefaultGoogle();
            break;
          case "sms":
            this.setDefaultSms();
            break;
        }
      }
    },

    mobileNameClass() {
      if (this.isMobileFocus) {
        return "mobile_name_focus";
      } else {
        if (!this.isMobileValid) {
          return "mobile_name_error";
        } else {
          if (this.mobile) {
            return "mobile_name_fill";
          } else {
            if (this.isMobileHover) {
              return "mobile_name_empty_hover";
            } else {
              return "mobile_name_empty";
            }
          }
        }
      }
    },

    isGoogleVerified() {
      return this.userVerifyInfo.is_google2fa_active;
    },

    isMobileVerified() {
      return this.userVerifyInfo.is_mobile_verified;
    },

    isEmailVerified() {
      return this.userVerifyInfo.is_email_verified;
    },

    // isGoogleDefault() {
    //   return this.defaultAuth === "google2fa";
    // },
    //
    // isSmsDefault() {
    //   return this.defaultAuth === "sms";
    // },

    isMobileValid() {
      if (this.mobile) {
        const mobileRegex = /^(09)\d{9}/;
        return mobileRegex.test(this.mobile);
      }
      return true;
    },

    isGoogleCodeValid() {
      if (this.authenticatorCode) {
        const phoneRegex = /^\d{1,6}$/;
        return phoneRegex.test(this.authenticatorCode);
      }
      return true;
    },

    isSmsCodeValid() {
      if (this.smsCode) {
        const phoneRegex = /^\d{1,6}$/;
        return phoneRegex.test(this.smsCode);
      }
      return true;
    },

    mobileData() {
      return this.userInfo?.mobile;
    }
  },
  methods: {
    ...mapActions({
      setStep: types.email.actions.SET_STEP,
      setUserData: types.userInfo.actions.ACTION_USER_INFO,
      setShow2FA: types.account.actions.SET_SHOW_2FA,
      setOtpSetting: types.account.actions.SET_SHOW_OTP_SETTING,
      setGoogleVerification: types.userInfo.actions.SET_GOOGLE_VERIFICATION,
      setSmsVerification: types.userInfo.actions.SET_SMS_VERIFICATION,
      setDefaultStrategy: types.userInfo.actions.SET_DEFAULT_STRATEGY,
      setMobileNumber: types.userInfo.actions.SET_MOBILE_NUMBER,
      setMobileVerification:
        types.userVerifyInfo.actions.SET_MOBILE_VERIFICATION,
      setUserVerifyInfo: types.userVerifyInfo.actions.SET_USER_VERIFY_INFO,
      setGoogleAuth: types.account.actions.SET_SHOW_GOOGLE_AUTH
    }),
    getUserInfoVerify() {
      UserService.getVerifyInfo().then(res => {
        this.setUserVerifyInfo(res.data.data);
      });
    },
    getUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
      });
    },
    show2FASection() {
      this.setShow2FA(true);
    },
    showOtpSettingFunc() {
      this.setOtpSetting(true);
    },

    showGoogleAuthSection() {
      this.setGoogleAuth(true);
    },
    // repairAutocomplete() {
    //   const el = this.$el;
    //   el.querySelectorAll('input[type="text"][autocomplete="off"').forEach(it => {
    //       it.setAttribute('autocomplete', 'new-password')
    //   })
    // },

    handleCountDown() {
      this.isCountDownFinish = true;
      this.ttl = "";
    },

    openAuthModal() {
      this.authModal = true;
    },

    closeAuthModal() {
      this.authModal = false;
    },

    authModalNext() {
      this.authModalStep++;
    },

    authModalBack() {
      this.authModalStep--;
    },

    openSmsModal() {
      this.smsModal = true;
    },
    // goToKYC() {
    //   this.$router.push({ name: "personal" });
    // },

    closeSmsModal() {
      this.smsModal = false;
    },
    openEmailModal() {
      this.emailModal = true;
    },

    closeEmailModal() {
      this.emailModal = false;
    },
    resetCounter() {
      this.isCountDownFinish = false;
    },
    setMobile(e) {
      this.mobile = e.target.value;
    },
    checkValidation() {
      this.errorText = "";
      if (this.emailInput) {
        if (!this.isEmailValid) {
          this.errorText = this.$t(
            "accountPage.identityInformation.contactInfo.email.emailValidation.invalid"
          );
        }
      } else {
        this.errorText = this.$t(
          "accountPage.identityInformation.contactInfo.email.emailValidation.empty"
        );
      }
    },
    activeEmail() {
      this.checkValidation();
      if (this.emailInput) {
        ContactService.activeEmail(this.emailInput)
          .then(res => {
            this.ttl = res.data.data.ttl;
            this.resetCounter();
            this.setStep(2);
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    },
    reActiveEmail() {
      ContactService.activeEmail(this.emailInput)
        .then(res => {
          this.ttl = res.data.data.ttl;
          this.resetCounter();
        })
        .finally(() => this.finishRequest());
      this.startRequest();
    },
    handleFinishCountDown() {
      this.isCountDownFinish = true;
      this.ttl = "";
    },
    verifyEmail() {
      ContactService.verifyEmail(this.emailCode)
        .then(res => {
          this.closeEmailModal();
          this.getUserInfo();
          this.getUserInfoVerify();
          this.$toast.success(res.data.message);
        })
        .finally(() => this.finishRequest());
      this.startRequest();
    },
    activeGoogle() {
      if (!(this.qrCode || this.secretCode)) {
        OtpService.activeGoogle()
          .then(res => {
            const { qrcode, secret } = res.data.data;
            this.qrCode = qrcode;
            this.secretCode = secret;
            this.authModalNext();
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      } else {
        this.authModalNext();
      }
    },

    verifyGoogle() {
      this.googleCodeError = false;
      this.googlePasswordError = false;

      if (!this.authenticatorCode) {
        this.googleCodeError = true;
      }

      if (!this.password) {
        this.googlePasswordError = true;
      }

      if (this.isGoogleCodeValid && this.password) {
        OtpService.verify("google2fa", this.authenticatorCode, this.password)
          .then(res => {
            this.getUserInfo();
            this.getUserInfoVerify();
            this.authModal = false;
            this.$toast.success(res.data.message);
            this.authenticatorCode = "";
            this.googlePasswordType = "text";
            this.password = "";
            this.authModalStep = 1;
          })
          .finally(() => {
            this.finishRequest();
          });
        this.startRequest();
      }
    },

    setMobileHover(bool) {
      this.isMobileHover = bool;
    },

    toggleMobileFocus() {
      this.isMobileFocus = !this.isMobileFocus;
    },

    resetMobileCounter() {
      this.isCountDownFinish = false;
    },

    activeSms() {
      OtpService.activeSms(this.mobileData ? this.mobileData : this.mobile)
        .then(res => {
          this.ttl = res.data.data.ttl;
          this.resetMobileCounter();
          this.smsModalStep++;
        })
        .finally(() => this.finishRequest());
      this.startRequest();
    },

    reactiveSms() {
      if (this.mobile || this.mobileData) {
        OtpService.activeSms(this.mobile ? this.mobile : this.mobileData)
          .then(res => {
            this.ttl = res.data.data.ttl;
            this.resetMobileCounter();
            this.$toast.success(res.data.message);
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    },

    checkSmsValidation() {
      this.smsCodeErrorText = "";
      this.smsPasswordErrorText = "";

      if (this.smsCode) {
        if (this.isSmsCodeValid) {
          if (!this.smsPassword) {
            this.smsPasswordErrorText = this.$t(
              "accountPage.identityInformation.contactInfo.mobile.validations.emptyPassword"
            );
          }
        } else {
          this.smsCodeErrorText = this.$t(
            "accountPage.identityInformation.contactInfo.mobile.validations.invalidCode"
          );
        }
      } else {
        this.smsCodeErrorText = this.$t(
          "accountPage.identityInformation.contactInfo.mobile.validations.emptyCode"
        );
      }
    },

    verifySms() {
      this.checkSmsValidation();
      if (this.isSmsCodeValid) {
        ContactService.verifyMobile(this.smsCode)
          .then(res => {
            this.smsModal = false;
            this.getUserInfoVerify();
            this.$toast.success(res.data.message);
            this.smsModalStep = 1;
            this.smsCode = "";
            this.smsPassword = "";
            this.smsPasswordType = "text";
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    },

    inactiveGoogle() {
      this.inactiveGooglePasswordError = false;
      if (this.inactiveGooglePassword) {
        OtpService.inactive("google2fa", this.inactiveGooglePassword)
          .then(res => {
            this.setGoogleVerification("inActive");
            this.closeInactiveGoogleModal();
            this.$toast.success(res.data.message);
            this.inactiveGooglePassword = "";
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      } else {
        this.inactiveGooglePasswordError = true;
      }
    },

    inactiveSms() {
      this.inactiveSmsPasswordError = false;
      if (this.inactiveSmsPassword) {
        OtpService.inactive("sms", this.inactiveSmsPassword)
          .then(res => {
            this.setSmsVerification("inActive");
            this.closeInactiveSmsModal();
            this.$toast.success(res.data.message);
            this.inactiveSmsPassword = "";
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      } else {
        this.inactiveSmsPasswordError = true;
      }
    },

    // setDefaultGoogle() {
    //   if (this.defaultAuth !== "google2fa" && !this.isRequesting) {
    //     OtpService.setDefault("google2fa")
    //       .then(res => {
    //         this.setDefaultStrategy("google2fa");
    //         this.$toast.success(res.data.message);
    //       })
    //       .finally(() => this.finishRequest());
    //     this.startRequest();
    //   }
    // },
    //
    // setDefaultSms() {
    //   if (this.defaultAuth !== "sms" && !this.isRequesting) {
    //     OtpService.setDefault("sms")
    //       .then(res => {
    //         this.setDefaultStrategy("sms");
    //         this.$toast.success(res.data.message);
    //       })
    //       .finally(() => this.finishRequest());
    //     this.startRequest();
    //   }
    // },

    openInactiveGoogleModal() {
      this.inactiveGoogleModal = true;
    },

    closeInactiveGoogleModal() {
      this.inactiveGoogleModal = false;
    },

    openInactiveSmsModal() {
      this.inactiveSmsModal = true;
    },

    closeInactiveSmsModal() {
      this.inactiveSmsModal = false;
    },

    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },

    toggleShowPassword() {
      this.showPassword = !this.showPassword;
      this.googlePasswordType =
        this.googlePasswordType === "password" ? "text" : "password";
    },

    toggleSmsPasswordVisibility() {
      this.showSmsPassword = !this.showSmsPassword;
      this.smsPasswordType =
        this.smsPasswordType === "password" ? "text" : "password";
    }
  },

  watch: {
    authenticatorCode(newValue, oldValue) {
      const value = this.$enDigits(newValue);
      this.authenticatorCode = value;
      const regex = /^\d+$/;
      const isCodeValid = regex.test(value);
      if (newValue) {
        if (!isCodeValid) {
          this.authenticatorCode = this.$enDigits(oldValue);
        }
      }
    },

    smsCode(newValue, oldValue) {
      const value = this.$enDigits(newValue);
      this.smsCode = value;
      const regex = /^\d+$/;
      const isCodeValid = regex.test(value);
      if (newValue) {
        if (!isCodeValid) {
          this.smsCode = this.$enDigits(oldValue);
        }
      }
    },

    mobile(newValue, oldValue) {
      const value = this.$enDigits(newValue);
      this.mobile = value;
      const digitReg = /^\d+$/;
      const isDigit = digitReg.test(value);
      if (newValue) {
        if (!isDigit) {
          this.mobile = oldValue;
        }
      }
    }
  }
};
